<template>
  <div class="mainbody">
    <div class="content-box side" style="width: 100%">
      <el-card shadow="hover">
        <el-form label-width="100px">
          <el-form-item label="设备编号">
            <b>{{ cabinetCode }}</b>
          </el-form-item>
          <el-form-item label="时间">
            <b>{{ time[0] }}~~{{ time[indexDate.length - 1] }}</b>
          </el-form-item>
          <!-- <el-form-item label="时间间隔">
            <el-radio-group v-model="radio">
              <el-radio :label="1">1分钟</el-radio>
              <el-radio :label="10">10分钟</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item label="选择时间">
            <div class="block">
              <span class="demonstration"></span>
              <el-date-picker
                v-model="value2"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="handleDateChange"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="时间间隔">
            <el-radio-group
              v-model="radio"
              @input="changeInput"
              v-bind="$attrs"
            >
              <el-radio :label="1">1分钟</el-radio>
              <el-radio :label="10">10分钟</el-radio>
            </el-radio-group>
          </el-form-item>
          <div
            id="dailyCharts"
            style="height: 282px; margin-top: 20px; margin-bottom: 40px"
          ></div>
        </el-form>
      </el-card>
      <!-- <el-button-group v-if="false">
        <el-button
          type="primary"
          icon="el-icon-document-checked"
          @click="downloadData"
          >导出</el-button
        >
      </el-button-group> -->
    </div>
  </div>
</template>
<script>
import {
  AxiosAjax,
  getModelData,
  getCompanyData,
  GetQueryValue,
} from "../../js/axios.config";
import * as echarts from "echarts"; //eslint-disable-line no-unused-vars
import { error } from "shelljs";

export default {
  data() {
    return {
      inheritAttrs: false,
      radio: 10,
      value2: "",
      cabinetCode: "", //当前选的设备
      indexDate: "",
      time: [],
      loadPower: [], //负载功率
      emmPower: [], //设备电表计量功率
      size: "",
    };
  },
  mounted() {
    this.cabinetCode = this.$route.query.cabinetCodes || "";
  },

  methods: {
    changeInput() {
      this.initLoad();
    },
    setEndOfDay(dateString) {
      const date = new Date(dateString);
      date.setHours(23, 59, 59, 999);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const seconds = date.getSeconds().toString().padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    handleDateChange(value) {
      this.initLoad();
    },
    toggleChage() {
      this.$router.push({ name: "CabinetList" });
    },

    //初始化工具栏
    initLoad: function () {
      let _this = this;
      this.indexDate = [];
      if (this.radio == 10) {
        let url =
          "/cabinet/cabinet/power/daily?cabinetCode=" +
          _this.$route.query.cabinetCodes;
        if (this.value2 != "" && this.value2 != null) {
          url +=
            "&startTime=" +
            this.value2 +
            "&endTime=" +
            this.setEndOfDay(this.value2);
        }
        AxiosAjax({
          url: url,
          success: function (res) {
            _this.indexDate = res.data.data;

            _this.picture();
          },
        });
      } else {
        let url =
          "/cabinet/cabinet/power/history?cabinetCode=" +
          _this.$route.query.cabinetCodes +
          "&size=300&&index=1";
        if (this.value2 != "" && this.value2 != null) {
          url +=
            "&startTime=" +
            this.value2 +
            "&endTime=" +
            this.setEndOfDay(this.value2);
        }
        AxiosAjax({
          url: url,
          success: function (res) {
            _this.indexDate = res.data.data.content;
            _this.size = res.data.data.pageCount;
            if (_this.size >= 2) {
              _this.initDate();
            } else {
              _this.picture();
            }
          },
        });
      }
    },
    getDate(url) {
      let _this = this;
      return new Promise((resolve, reject) => {
        AxiosAjax({
          url: url,
          success: (res) => {
            _this.indexDate.push(...res.data.data.content);
            if (_this.indexDate.length == res.data.data.total) {
              _this.picture();
            }
            resolve(); // 请求成功后，解决 Promise
          },
        });
      });
    },
    async initDate() {
      let _this = this;

      for (let i = 2; i <= this.size; i++) {
        let url =
          "/cabinet/cabinet/power/history?cabinetCode=" +
          _this.$route.query.cabinetCodes +
          "&size=300&index=" +
          i;
        if (this.value2 != "" && this.value2 != null) {
          url +=
            "&startTime=" +
            this.value2 +
            "&endTime=" +
            this.setEndOfDay(this.value2);
        }
        try {
          await this.getDate(url);
        } catch (error) {
          break;
        }
        // AxiosAjax({
        //   url: url,
        //   success: function (res) {
        //     _this.indexDate.push(...res.data.data.content);
        //     if (_this.indexDate.length == res.data.data.total) {
        //       _this.picture();
        //     }
        //   },
        // });
      }
    },
    picture() {
      let dailyChart = echarts.init(document.getElementById("dailyCharts"));
      console.log(this.indexDate);
      this.indexDate.sort((a, b) => {
        return new Date(a.deviceTime) - new Date(b.deviceTime);
      });
      this.time = [];
      this.emmPower = [];
      this.loadPower = [];
      this.indexDate.forEach((item) => {
        this.time.push(item.deviceTime);
        this.emmPower.push(item.emmPower);
        this.loadPower.push(item.loadPower);
      });

      let option = {
        title: {
          text: "功率曲线",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["负载功率", "设备电表计量功率"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },

        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.time,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "负载功率",
            type: "line",
            data: this.loadPower,
          },
          {
            name: "设备电表计量功率",
            type: "line",
            data: this.emmPower,
          },
        ],
      };
      dailyChart.setOption(option);
    },
    downloadData() {
      const filteredData = this.indexDate.map((item) => ({
        deviceTime: item.deviceTime,
        loadPower: item.loadPower,
        emmPower: item.emmPower,
      }));
      // 2. 构建 CSV 内容
      let csvContent = "data:text/csv;charset=utf-8,";

      // 添加 BOM 标记，解决 Excel 打开乱码问题
      csvContent += "\ufeff";
      // 添加表头
      csvContent += "时间,负载功率,设备电表计量功率\n";

      // 添加数据行
      filteredData.forEach((item) => {
        csvContent += `${item.deviceTime},${item.loadPower},${item.emmPower}\n`;
      });

      // 3. 创建下载链接
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);

      // 修改文件名（例如：power_data_2025-06-18.csv）
      const today = new Date();
      const dateStr = today.toISOString().split("T")[0];
      link.setAttribute("download", `power_data_${dateStr}.csv`);

      // 4. 触发下载
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
  created: function () {
    //加载数据
    this.initLoad();
  },
};
</script>
<style scoped>
.toolbar-box .more-box {
  justify-content: flex-start;
}

.toolbar-box .more-box dl {
  margin-right: 10px;
}

.interval-box {
  width: 120px;
  display: inline-block;
  margin: 0px 10px;
}
.dl-box-fee div {
  height: 35px;
  line-height: 35px;
}
.mainbody {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Monitor/PowerCurve.vue